import { Directive, ElementRef, HostListener, Input, Renderer2 } from "@angular/core";

@Directive({
  selector: "[preventMultipleClicks]",
})
export class PreventMultipleClicksDirective {
  @Input() disableSeconds: number = 2;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener("click", ["$event"])
  onClick(event: Event) {
    const button = this.el.nativeElement;

    button.disabled = true;

    this.renderer.setStyle(button, "cursor", "not-allowed");
    this.renderer.addClass(button, "waiting");

    setTimeout(() => {
      button.disabled = false;
      this.renderer.removeStyle(button, "cursor");
      this.renderer.removeClass(button, "waiting");
    }, this.disableSeconds * 1000);
  }
}
